import { Injectable, EventEmitter } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { HttpErrorResponse } from '@angular/common/http';

import * as HttpStatus from 'http-status-codes';

import { Helper } from '../helper';

@Injectable()
export class UsersService {
  API = this.helper.getApi();
  endPoint: string;
  currentUser: any = this.helper.getStorage('currentUser');
  onSetLoggedIn: EventEmitter<any> = new EventEmitter();

  constructor(private http: Http, public helper: Helper) {}

  updateProfile(profileData: {}): Observable<any> {
    const headerOptions = this.helper.buildAuthHeader();

    return this.http
      .post(
        `${this.API}/users/profile`,
        JSON.stringify(profileData),
        headerOptions
      )
      .pipe(
        map((response: Response) => {
          return response.json();
        }),
        catchError((err: HttpErrorResponse) => {
          return of({ status: err.status });
        })
      )
  }

  signup(signupData: {}): Observable<any> {
    const headerOptions = this.helper.buildAuthHeader();

    return this.http
      .post(
        `${this.API}/users/register`,
        JSON.stringify(signupData),
        headerOptions
      )
      .pipe(
        map((response: Response) => {
          return response.json();
        }),
        catchError((err: HttpErrorResponse) => {
          return of({ status: err.status });
        })
      );
  }

  login(data: any): Observable<any> {
    const headers = new Headers({ 'Content-Type': 'application/json' });
    const options = new RequestOptions({ headers: headers });

    if (data.token) {
      this.endPoint = 'external-authenticate';
    } else {
      this.endPoint = 'authenticate';
    }

    return this.http
      .post(`${this.API}/users/${this.endPoint}`, JSON.stringify(data), options)
      .pipe(
        map((response: Response) => {
          const result = response.json();

          if (result.status === HttpStatus.OK) {
            const userData = result.response;

            localStorage.setItem(
              'currentUser',
              JSON.stringify({
                data: userData.data,
                token: userData.token,
                _id: userData._id,
                lastBooking: userData.lastBooking,
              })
            );
          } else {
            console.error('Error in auth', result);
          }

          return result;
        })
      );
  }

  resetPassword(resetData: {}): Observable<any> {
    const headerOptions = this.helper.buildAuthHeader();

    return this.http
      .post(
        `${this.API}/users/reset-password`,
        JSON.stringify(resetData),
        headerOptions
      )
      .pipe(
        map((response: Response) => {
          return response.json();
        })
      );
  }

  forgotPassword(forgotData: {}): Observable<any> {
    const headerOptions = this.helper.buildAuthHeader();

    return this.http
      .post(
        `${this.API}/users/forgot-password`,
        JSON.stringify(forgotData),
        headerOptions
      )
      .pipe(
        map((response: Response) => {
          return response.json();
        })
      );
  }

  loginWithCpr(loginData: {}): Observable<any> {
    const headerOptions = this.helper.buildAuthHeader();

    return this.http
      .post(
        `${this.API}/users/external-digi-authenticate`,
        JSON.stringify(loginData),
        headerOptions
      )
      .pipe(
        map((response: Response) => {
          return response.json();
        })
      );
  }

  checkClinics(clinicsData: {}): Observable<any> {
    const headerOptions = this.helper.buildAuthHeader();

    return this.http
      .post(
        `${this.API}/users/check-clinics`,
        clinicsData,
        headerOptions
      )
      .pipe(
        map((response: Response) => {
          return response.json();
        })
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/services/users.service.ts